import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './index.module.css';
import AnimatedGrid from '@components/AnimatedGrid';

const getAspectRatio = (image) => {
    if (!image?.width || !image?.height) {
        return 1;
    }
    return image.width / image.height;
};

const getAspectRows = (image, sectionAspect = 16) => {
    const imageRatio = getAspectRatio(image);
    const rows = Math.floor( sectionAspect / imageRatio);

    return Math.min(
        Math.max(rows, 1),
        sectionAspect
    );
};



const Banner = ({ image }) => {

    const D_COLS = 16;
    const M_COLS = 6;

    const imageAspect = getAspectRatio(image);

    const desktopRows = getAspectRows( image, D_COLS);

    const mobileRows = getAspectRows( image, M_COLS );
    
    const dataSquares = {
        dCells: [
            {
                id: '1-1',
                color: 'beige',
            },
            {
                id: `1-${D_COLS}`,
                color: 'orange',
            },
            {
                id: '2-2',
                color: 'blueLight',
            },
            {
                id: `2-${D_COLS - 1}`,
                color: 'beige',
            },
            {
                id: '3-1',
                color: 'black',
            },
            {
                id: `${desktopRows}-1`,
                color: 'white',
            },
            {
                id: `${desktopRows}-${D_COLS}`,
                color: 'beige',
            },
            
        ],
        mCells: [
            {
                id: '1-1',
                color: 'beige',
            },
            {
                id: `1-${M_COLS}`,
                color: 'orange',
            },
            {
                id: '2-2',
                color: 'blueLight',
            },
            {
                id: `2-${M_COLS - 1}`,
                color: 'beige',
            },
            {
                id: '3-1',
                color: 'black',
            },
            {
                id: `${mobileRows}-1`,
                color: 'white',
            },
            {
                id: `${mobileRows}-${M_COLS}`,
                color: 'beige',
            },
        ]
    };

    return (
        <div 
            className={classes.root}
            style={{
                '--dAspect': `${D_COLS} / ${desktopRows}`,
                '--mAspect': `${M_COLS} / ${mobileRows}`,
            }}
        >
            <div className={classes.imageContainer}>
                <AnimatedGrid
                    dImage={{
                        src: image,
                        alt: 'Desktop image',
                        start: '1-1',
                        align: 'top, right',
                        widthCells: D_COLS,
                        aspectRatio: imageAspect,
                    }}
                    mImage={{
                        src: image,
                        alt: 'Mobile image',
                        start: '1-1',
                        align: 'top, left',
                        widthCells: M_COLS,
                        aspectRatio: imageAspect,
                    }}
                    dCells={dataSquares?.dCells}
                    mCells={dataSquares?.mCells}
                    dCols={D_COLS}
                    dRows={desktopRows}
                    mCols={M_COLS}
                    mRows={mobileRows}
                />
            </div>
        </div>
    );
};

Banner.propTypes = {
    image: PropTypes.object,
};

export default Banner;